
import { Union, Record } from "./fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type, string_type, record_type, option_type, tuple_type, class_type, bool_type } from "./fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Url_$reflection } from "./Routes.js";
import { AccountSettings_$reflection, CustomerConfiguration_$reflection, RequestedValue$1_$reflection, TokenDataDto_$reflection } from "./Shared/Shared.js";
import { Requests_UserAccountExistsResponse_$reflection, User_$reflection } from "./Shared/User.js";
import { RolePermissionsDto_$reflection } from "./Shared/Roles.js";
import { HubSpotChatSettingsDto_$reflection } from "./Shared/Support.js";

export class State extends Record {
    constructor(IsInTestphase, CurrentUrl, UserData, Configuration, AccountSettings, CurrentUser, Permissions, UserAccountExists, HealthFetched, OnboardingWizardCompleted, NavigateToLandingPage, HubSpotChatSettings) {
        super();
        this.IsInTestphase = IsInTestphase;
        this.CurrentUrl = CurrentUrl;
        this.UserData = UserData;
        this.Configuration = Configuration;
        this.AccountSettings = AccountSettings;
        this.CurrentUser = CurrentUser;
        this.Permissions = Permissions;
        this.UserAccountExists = UserAccountExists;
        this.HealthFetched = HealthFetched;
        this.OnboardingWizardCompleted = OnboardingWizardCompleted;
        this.NavigateToLandingPage = NavigateToLandingPage;
        this.HubSpotChatSettings = HubSpotChatSettings;
    }
}

export function State_$reflection() {
    return record_type("Client.Types.State", [], State, () => [["IsInTestphase", tuple_type(bool_type, class_type("System.DateTime"))], ["CurrentUrl", Url_$reflection()], ["UserData", RequestedValue$1_$reflection(option_type(TokenDataDto_$reflection()))], ["Configuration", RequestedValue$1_$reflection(CustomerConfiguration_$reflection())], ["AccountSettings", RequestedValue$1_$reflection(AccountSettings_$reflection())], ["CurrentUser", RequestedValue$1_$reflection(User_$reflection())], ["Permissions", RequestedValue$1_$reflection(RolePermissionsDto_$reflection())], ["UserAccountExists", RequestedValue$1_$reflection(bool_type)], ["HealthFetched", RequestedValue$1_$reflection(bool_type)], ["OnboardingWizardCompleted", bool_type], ["NavigateToLandingPage", bool_type], ["HubSpotChatSettings", option_type(HubSpotChatSettingsDto_$reflection())]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoginSuccessfull", "FetchBaseData", "RemoveLoginParameter", "ParseToken", "ParseTokenFromParam", "Logout", "UrlChanged", "ConfigurationFetched", "AccountSettingsFetched", "UserAccountExistsFetchedAfterLogin", "UserAccountExistsFetchedAfterParsingToken", "UserFetchedAfterLogin", "UserFetchedAfterParsingToken", "PermissionsFetched", "HubSpotChatSettingsFetched", "HealthFetched", "FetchError", "OnboardingWizardCompleted"];
    }
}

export function Msg_$reflection() {
    return union_type("Client.Types.Msg", [], Msg, () => [[["Item", string_type]], [], [], [], [], [], [["Item", Url_$reflection()]], [["Item", CustomerConfiguration_$reflection()]], [["Item", AccountSettings_$reflection()]], [["Item", Requests_UserAccountExistsResponse_$reflection()]], [["Item", Requests_UserAccountExistsResponse_$reflection()]], [["Item", User_$reflection()]], [["Item", User_$reflection()]], [["Item", RolePermissionsDto_$reflection()]], [["Item", option_type(HubSpotChatSettingsDto_$reflection())]], [["Item", string_type]], [["Item", class_type("System.Exception")]], []]);
}

